<template>
  <footer class="bg-white w-full relative">
    <div class="bg-white z-20 w-full">
      <div class="flex flex-wrap md:flex-no-wrap mb-16 z-20 xl:mb-0">
        <img
          class="z-30 relative hidden lg:block w-1/3"
          src="/assets/hero-group.png"
        />
        <div
          v-for="footerItem in footer"
          :key="footerItem.order"
          class="flex flex-col w-full md:w-1/2 xl:w-1/4 xl:pb-16 xl:pt-8 z-20 p-4 md:pl-20"
        >
          <h4 class="font-headline text-lg font-medium my-4">
            {{ footerItem.title }}
          </h4>
          <a
            v-for="entry in footerItem.entries"
            :key="entry.name"
            class="text-sm leading-loose flex items-center"
            :href="entry.href"
            ><img v-if="entry.img" :src="entry.img" class="h-6 mr-2" />
            {{ entry.name }}</a
          >
        </div>
      </div>
      <div class="container md:my-0 flex z-20 relative flex-col mx-auto">
        <div class="w-full mb-20 md:mb-12 text-center sm:text-white text-sm">
          Copyright © 2010-2019 Heidolph Instruments GmbH & Co / RotaChrom
        </div>
      </div>
    </div>
    <div class="absolute bottom-0 bg-no-repeat flex w-full">
      <img src="/assets/footer-overlay.png" />
    </div>
  </footer>
</template>

<script>
import domainMixin from "../mixins/domain";
import { sortBy } from "lodash";

export default {
  name: "RoHFooter",
  props: {},
  data() {
    return {
      footer: [],
    };
  },
  components: {},
  mixins: [domainMixin],
  mounted() {
    this.footer = this.getFooter();
    this.footer = sortBy(this.footer, "order");
  },
};
</script>

<style scoped></style>
